// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXeth } from "../../../icons/mono/build/icon-xeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XethIcon.displayName = 'XethIcon';
}

export default XethIcon;